var exports = {
  "Vd": "x61f99309--0acbc3--slideUp",
  "kL": "x61f99309--0acbc3--container",
  "su": "x61f99309--0acbc3--icon-wrapper",
  "hD": "x61f99309--0acbc3--quote",
  "PQ": "x61f99309--0acbc3--border",
  "Qq": "x61f99309--0acbc3--text",
  "_R": "x61f99309--0acbc3--close-button",
  "dC": "x61f99309--0acbc3--doc-icon",
};

module.exports = exports;
